<template>
  <div class="role-add">
    <div style="width: 50%;">
      <h3>角色</h3>
      <el-input
        v-model="roleName"
        placeholder="角色名"
      />
    </div>
    <div class="menu-list">
      <h3>菜单</h3>
      <el-table
        ref="table"
        :data="menus"
        style="width: 100%;"
        tooltip-effect="dark"
        row-key="id"
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @selection-change="menuSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          prop="name"
          label="菜单名"
          width="180"
        />
        <el-table-column
          prop="code"
          label="菜单编码"
        />
      </el-table>
    </div>
    <div class="permission-list">
      <h3>权限</h3>
      <el-table
        :data="permissions"
        style="width: 100%;"
        tooltip-effect="dark"
        @selection-change="permissionSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          prop="name"
          label="权限名"
          width="180"
        />
        <el-table-column
          prop="code"
          label="权限编码"
          width="180"
        />
        <el-table-column
          prop="router"
          label="后端路由"
        />
      </el-table>
    </div>
    <div
      v-show="isShowError"
      style="margin-top: 30px;"
    >
      <el-alert
        title="请至少选择一个菜单或者权限"
        type="error"
        :closable="false"
      />
    </div>
    <div class="footer">
      <el-button
        type="primary"
        size="small"
        @click="submitForm"
      >
        保存
      </el-button>
      <el-button
        size="small"
        @click="$router.back()"
      >
        取消
      </el-button>
    </div>
  </div>
</template>
<style lang="less">
.role-add {
  .footer {
    margin-top: 20px;
  }
}
</style>
<script>
const debug = require('debug')('ccs:ctrl:role_add');
import axios from 'axios';

export default {
	data() {
		return {
			roleName: '', // 用户名
			isShowError: false, // 是否展示错误
			menus: [],
			permissions: [],

			menuSelection: [],
			permissionSelection: []
		};
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			const [menus, permissions] = await Promise.all([
				axios.get('/api/menus', {
					params: {
						// flat: true
					}
				}),
				axios.get('/api/permissions')
			]);

			this.menus = menus;
			this.permissions = permissions;
		},

		menuSelectionChange(val) {
			this.menuSelection = val;
		},
		permissionSelectionChange(val) {
			this.permissionSelection = val;
		},

		async submitForm() {
			if (this.permissionSelection.length || this.menuSelection.length) {
				this.isShowError = false;
				await axios.post('/api/roles', {
					name: this.roleName,
					menus: this.menuSelection.map(menu => menu.id),
					permissions: this.permissionSelection.map(permission => permission.id)
				});
				this.$router.push({ name: 'roles' });
			} else {
				this.isShowError = true;
			}
		}
	}
};
</script>